import { useHLName } from '@/features/navbar/logic/useHLName'
import { Typography } from '@/ui/atoms/typography/Typography'
import { shortenAddress } from '@/ui/utils/shortenAddress'
import { cn } from '@/ui/utils/style'
import { Address } from 'viem'

interface AccountDisplayProps {
  address: Address | undefined
  className?: string
  shortenOptions?: {
    startLength?: number
    endLength?: number
  }
}

export function AccountDisplay({
  address,
  className,
  shortenOptions = { startLength: 3, endLength: 3 },
}: AccountDisplayProps) {
  const { data: hlName, isError: hlNameError } = useHLName(address)

  const accountDisplay = (() => {
    switch (true) {
      case !!hlName && !hlNameError:
        return hlName
      case !!address:
        return shortenAddress(address as Address, shortenOptions)
      default:
        return ''
    }
  })()

  return <Typography className={cn('font-bold text-xs', className)}>{accountDisplay}</Typography>
}
